import { Grid } from "@mui/material";
import { Widget } from "Components/Shared/Widget/Widget";
import { Resources, useResource } from "Translations/Resources";

type Props = {
  openRegistrations: number;
  invitationsSent: number;
  inOnboarding: number;
  completed: number;
};

export const MerchantsStatusWidgets = ({
  openRegistrations,
  invitationsSent,
  inOnboarding,
  completed,
}: Props) => {
  const { t } = useResource();

  return (
    <Grid container spacing={2} alignItems="stretch" my={4}>
      <Widget
        title={t(
          Resources.Pages.Content.Merchants.StatusWidgets.OpenRegistrations,
        )}
      >
        {openRegistrations}
      </Widget>
      <Widget
        title={t(
          Resources.Pages.Content.Merchants.StatusWidgets.InvitationsSent,
        )}
      >
        {invitationsSent}
      </Widget>
      <Widget
        title={t(Resources.Pages.Content.Merchants.StatusWidgets.InOnboarding)}
      >
        {inOnboarding}
      </Widget>
      <Widget
        title={t(Resources.Pages.Content.Merchants.StatusWidgets.Completed)}
      >
        {completed}
      </Widget>
    </Grid>
  );
};
